import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewCrossReferencesQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewCrossReferencesQuery = { __typename?: 'query_root', get_plan_review_cross_references: Array<{ __typename?: 'PlanReviewRequirementCrossReferencesOutput', requirement_id: any, omitted_count: number, sections: Array<{ __typename?: 'PlanReviewCrossReferenceSectionOutput', code_section_id: any, section_number: string, title?: string | null, page_number?: number | null, referenced_by: Array<string>, code_book: { __typename?: 'PlanReviewCrossReferenceCodeBookOutput', id: any, abbreviation: string, edition_year?: number | null, book_type?: string | null, source_file_url?: string | null } }> }> };


export const GetPlanReviewCrossReferencesDocument = gql`
    query getPlanReviewCrossReferences($jurisdictionId: uuid!) {
  get_plan_review_cross_references(jurisdiction_id: $jurisdictionId) {
    requirement_id
    omitted_count
    sections {
      code_section_id
      section_number
      title
      page_number
      referenced_by
      code_book {
        id
        abbreviation
        edition_year
        book_type
        source_file_url
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewCrossReferencesQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewCrossReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewCrossReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewCrossReferencesQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetPlanReviewCrossReferencesQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewCrossReferencesQuery, GetPlanReviewCrossReferencesQueryVariables> & ({ variables: GetPlanReviewCrossReferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewCrossReferencesQuery, GetPlanReviewCrossReferencesQueryVariables>(GetPlanReviewCrossReferencesDocument, options);
      }
export function useGetPlanReviewCrossReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewCrossReferencesQuery, GetPlanReviewCrossReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewCrossReferencesQuery, GetPlanReviewCrossReferencesQueryVariables>(GetPlanReviewCrossReferencesDocument, options);
        }
export function useGetPlanReviewCrossReferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewCrossReferencesQuery, GetPlanReviewCrossReferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewCrossReferencesQuery, GetPlanReviewCrossReferencesQueryVariables>(GetPlanReviewCrossReferencesDocument, options);
        }
export type GetPlanReviewCrossReferencesQueryHookResult = ReturnType<typeof useGetPlanReviewCrossReferencesQuery>;
export type GetPlanReviewCrossReferencesLazyQueryHookResult = ReturnType<typeof useGetPlanReviewCrossReferencesLazyQuery>;
export type GetPlanReviewCrossReferencesSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewCrossReferencesSuspenseQuery>;
export type GetPlanReviewCrossReferencesQueryResult = Apollo.QueryResult<GetPlanReviewCrossReferencesQuery, GetPlanReviewCrossReferencesQueryVariables>;